import moment from "moment";
import { IAlertModel } from '../../models/LeadTimes';
import { exportProductCatalog as callExportProductCatalog } from '../../products/api/ProductCatalogApi';
import { productCatalogSlice, callTypes } from "./ProductCatalogSlice";

const { actions } = productCatalogSlice;
const errorTitle = 'Error while calling API';

export const exportProductCatalog =
  (productType: string) => async (dispatch: (args: any) => void) => {
    dispatch(actions.startCall({ callType: callTypes.download }));
    try {
      const catalogData = await callExportProductCatalog(productType);
      dispatch(actions.catalogDownloaded());
      const uniqueUrl = `product-catalog-${productType}`;

      const url = window.URL.createObjectURL(catalogData);
      const link = document.createElement('a');
      link.href = url;
      const dateTime = moment().format('YYYY-MM-DD_HH-mm-ss');
      link.download = `${uniqueUrl}-${dateTime}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      const error = {
        title: errorTitle,
        message: "Can't download product catalog",
        variant: 'danger'
      } as IAlertModel;
      console.error(err);
      dispatch(actions.catchError({ error, callType: callTypes.download }));
    }
  };
